<template>
  <v-container>
    <v-row>
      <v-col sm="12" md="8">
        <v-row>
          <v-col sm="12">
            <h2 class="text-h2">Vyzvednutí a platba</h2>
          </v-col>
        </v-row>

        <template v-if="loading">
          <v-row>
            <v-col sm="12">
              <v-skeleton-loader
                class="mx-auto"
                type="card"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </template>

        <template v-if="!loading">
          <v-row v-if="orderr == null">
            <v-col sm="12">
              <v-alert
                border="bottom"
                colored-border
                type="warning"
                elevation="2"
                class="my-5"
              >
                Nenašli jsme žádnou rozpracovanou rezervaci.
              </v-alert>
            </v-col>
          </v-row>
          <v-row v-if="orderr == null">
            <v-col sm="12" md="8">
              <v-btn @click="goToRent" color="primary">
                Vytvořit novou rezervaci
              </v-btn>
            </v-col>
          </v-row>

          <template v-if="orderr != null">
            <v-row>
              <v-col sm="12" md="6">
                <h4 class="text-h4 mb-3">Místo vyzvednutí</h4>
                <p>
                  {{ orderr.pointSell.addressName }} <br />
                  {{ orderr.pointSell.addressStreet }}<br />
                  {{ orderr.pointSell.addressPostalCode }}
                  {{ orderr.pointSell.addressCity }} <br />
                  GPS: <span v-html="orderr.pointSell.gps"></span>
                </p>
                <h4 class="text-h4 mb-3">Datum vyzvednutí</h4>
                <p class="subtitle-1">
                  {{ firstDateOfRentFormated }}
                </p>
              </v-col>

              <v-col sm="12" md="6">
                <h5>Otevírací doba pobočky:</h5>
                <table>
                  <tr>
                    <td>Pondělí:</td>
                    <td>
                      {{ orderr.pointSell.openHoursMondayFrom }} -
                      {{ orderr.pointSell.openHoursMondayTo }}
                    </td>
                  </tr>
                  <tr>
                    <td>Úterý:</td>
                    <td>
                      {{ orderr.pointSell.openHoursTuesdayFrom }} -
                      {{ orderr.pointSell.openHoursTuesdayTo }}
                    </td>
                  </tr>
                  <tr>
                    <td>Středa:</td>
                    <td>
                      {{ orderr.pointSell.openHoursWednesdayFrom }} -
                      {{ orderr.pointSell.openHoursWednesdayTo }}
                    </td>
                  </tr>
                  <tr>
                    <td>Čtvrtek:</td>
                    <td>
                      {{ orderr.pointSell.openHoursThursdayFrom }} -
                      {{ orderr.pointSell.openHoursThursdayTo }}
                    </td>
                  </tr>
                  <tr>
                    <td>Pátek:</td>
                    <td>
                      {{ orderr.pointSell.openHoursFridayFrom }} -
                      {{ orderr.pointSell.openHoursFridayTo }}
                    </td>
                  </tr>
                  <tr>
                    <td>Sobota:</td>
                    <td>
                      {{ orderr.pointSell.openHoursSaturdayFrom }} -
                      {{ orderr.pointSell.openHoursSaturdayTo }}
                    </td>
                  </tr>
                  <tr>
                    <td>Neděle:</td>
                    <td>
                      {{ orderr.pointSell.openHoursSundayFrom }} -
                      {{ orderr.pointSell.openHoursSundayTo }}
                    </td>
                  </tr>
                </table>
              </v-col>

              <v-col sm="12">
                <h3 class="text-h4 mb-5">Způsob platby</h3>
                <v-radio-group v-model="selectedPaymentMethod" mandatory>
                  <v-radio v-if="cardOnlineEnabled" value="CARD_ONLINE">
                    <template v-slot:label>
                      <div>
                        {{ $t("CARD_ONLINE") }}
                      </div>
                      <!-- <div>
                        Obrazek here...
                        <v-img
                          alt="VISA"
                          contain
                          transition="scale-transition"
                          width="100"
                        />
                      </div> -->
                    </template>
                  </v-radio>
                  <v-radio
                    v-if="cardOfflineEnabled"
                    value="CARD_OFFLINE"
                    :label="$t('CARD_OFFLINE')"
                  ></v-radio>
                  <v-radio
                    v-if="cashOfflineEnabled"
                    value="CASH_OFFLINE"
                    :label="$t('CASH_OFFLINE')"
                  ></v-radio>
                  <v-radio
                    v-if="bankTransferEnabled"
                    value="BANK_TRANSFER"
                    :label="$t('BANK_TRANSFER')"
                  ></v-radio>
                </v-radio-group>
              </v-col>

              <!--
          <v-col sm="12">
            <h3 class="text-h4 mb-5">Slevový kupón</h3>
            <v-text-field label="Kód slevového kupónu"></v-text-field>
          </v-col>
          -->
            </v-row>

            <v-row v-if="mobConfig.checkoutStaticInfo">
              <v-col sm="12">
                <v-alert
                  border="top"
                  outlined
                  type="info"
                  elevation="1"
                  class="my-5"
                  v-html="mobConfig.checkoutStaticInfo"
                ></v-alert>
              </v-col>
            </v-row>
          </template>
        </template>
      </v-col>

      <v-col sm="12" md="4">
        <v-card v-if="!loading && orderr != null">
          <v-card-title> Přehled objednávky </v-card-title>

          <v-card-text>
            <orderr-summary
              v-bind:orderr="orderr"
              showExpirationTime
              showStatus
              showRentalPeriod
              showPrice
            ></orderr-summary>
          </v-card-text>

          <v-card-actions class="pt-0">
            <v-btn
              block
              color="primary accent-4"
              :loading="submiting"
              :disabled="selectedPaymentMethod == null || currentOrderrExpired"
              @click="goToCheckoutContacts()"
            >
              Pokračovat
            </v-btn>
          </v-card-actions>
        </v-card></v-col
      >
    </v-row>
  </v-container>
</template>

<style lang="css">
table tr td {
  padding: 0.1rem 0.5rem;
}
</style>

<script>
import OrderrSummary from "@/components/OrderrSummary";
const moment = require("moment");

export default {
  components: {
    OrderrSummary,
  },

  async mounted() {
    // nastavit stav, ze se nacita
    this.loading = true;

    // zkontrolovat, ze je uzivatel prihlaseny a dalsi nutne prerekvizity
    if (
      this.$store.state.user == null ||
      this.$store.state.appInstance == null
    ) {
      console.log("Nesplnene prerekvizity user nebo app instance jsou null");
      this.$router.push({ name: "rent" });
    }

    // nacist aktualni objednavku s polozkami
    await this.$store.dispatch("loadCurrentOrderrDRAFT");

    // dokoncit nacitani - zmena stavu
    this.loading = false;
  },

  data: () => ({
    selectedPaymentMethod: null,
    loading: false,
    submiting: false,
  }),

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    orderr() {
      return this.$store.state.currentOrderr;
    },

    cardOnlineEnabled() {
      let enabled = false;
      for (let i = 0; i < this.paymentMethods.length; i++) {
        if (this.paymentMethods[i] == "CARD_ONLINE") {
          enabled = true;
        }
      }
      return enabled;
    },

    cardOfflineEnabled() {
      let enabled = false;
      for (let i = 0; i < this.paymentMethods.length; i++) {
        if (this.paymentMethods[i] == "CARD_OFFLINE") {
          enabled = true;
        }
      }
      return enabled;
    },

    cashOfflineEnabled() {
      let enabled = false;
      for (let i = 0; i < this.paymentMethods.length; i++) {
        if (this.paymentMethods[i] == "CASH_OFFLINE") {
          enabled = true;
        }
      }
      return enabled;
    },

    bankTransferEnabled() {
      let enabled = false;
      for (let i = 0; i < this.paymentMethods.length; i++) {
        if (this.paymentMethods[i] == "BANK_TRANSFER") {
          enabled = true;
        }
      }
      return enabled;
    },

    currentOrderrExpired() {
      return this.$store.state.currentOrderrExpired;
    },

    firstDayOfRent() {
      if (this.$store.state.currentOrderr == null) {
        return "--";
      }

      let oigs = this.$store.state.currentOrderr.orderrItemGroups.items;
      let date = null;

      console.log(this.$store.state.currentOrderr.orderrItemGroups.items);
      for (let i = 0; i < oigs.length; i++) {
        let oigDate = oigs[i].dateStart;
        if (date == null) {
          date = oigDate;
        }
        date = date < oigDate ? date : oigDate;
      }

      return date;
    },

    firstDateOfRentFormated() {
      return moment(this.firstDayOfRent).format("D. M. YYYY");
    },

    paymentMethods() {
      return this.$store.state.mobConfig.paymentMethods;
    },
  },

  methods: {
    goToRent() {
      this.$router.push({ name: "rent" });
    },

    async goToCheckoutContacts() {
      console.log("goToCheckoutContacts");
      console.log(this.orderr);
      console.log(this.firstDayOfRent);
      console.log(this.selectedPaymentMethod);
      console.log("goToCheckoutContacts - 2");

      this.submiting = true;
      try {
        await this.$store.dispatch("updateOrderrPickupAndPaymentInfo", {
          orderrId: this.orderr.id,
          datePickUp: this.firstDayOfRent,
          paymentMethod: this.selectedPaymentMethod,
        });
      } catch (error) {
        console.log(error);
      }

      this.submiting = false;

      this.$router.push({ name: "checkout-contacts" });
    },
  },
};
</script>
